let chalkColor = 'rgba(245, 250, 255, 0.92)';
let chalkGlow = 'rgba(245, 250, 255, 0.25)';
let shadowBlur = 6;
let jitterPx = 0.6;
let jitterMultiplier = 1;
let chalkRoles = {};

export function setChalkTheme(theme) {
  chalkColor = theme.color;
  chalkGlow = theme.glow;
  shadowBlur = theme.shadowBlur;
  jitterPx = theme.jitterPx;
  const isMobileViewport =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(max-width: 768px)').matches;
  // Reduce micro-jitter on mobile where frame pacing can make chalk noise look like flicker.
  jitterMultiplier = isMobileViewport ? 0.25 : 1;
  chalkRoles = theme.roles || {};
}

function jitter() {
  return (Math.random() - 0.5) * jitterPx * jitterMultiplier;
}

function resolveRole(role) {
  if (!role || !chalkRoles[role]) {
    return { color: chalkColor, glow: chalkGlow };
  }
  const entry = chalkRoles[role];
  if (typeof entry === 'string') {
    return { color: entry, glow: chalkGlow };
  }
  return {
    color: entry.color || chalkColor,
    glow: entry.glow || chalkGlow,
  };
}

export function getChalkRole(role) {
  return resolveRole(role);
}

export function chalkText(
  ctx,
  text,
  x,
  y,
  size,
  alpha = 1.0,
  font = 'sans-serif',
  align = 'left',
  options = {}
) {
  ctx.save();
  const role = resolveRole(options.role);
  ctx.font = `${size}px ${font}`;
  ctx.textAlign = align;
  ctx.textBaseline = 'alphabetic';
  ctx.fillStyle = role.color.replace(/[\d.]+\)$/, `${alpha})`);
  ctx.shadowColor = role.glow;
  ctx.shadowBlur = shadowBlur;

  const jx = x + jitter();
  const jy = y + jitter();
  ctx.fillText(text, jx, jy);

  ctx.restore();
}

export function chalkLine(ctx, x1, y1, x2, y2, width, alpha = 1.0, options = {}) {
  ctx.save();
  const role = resolveRole(options.role);
  ctx.strokeStyle = role.color.replace(/[\d.]+\)$/, `${alpha})`);
  ctx.lineWidth = width;
  ctx.shadowColor = role.glow;
  ctx.shadowBlur = shadowBlur;
  ctx.lineCap = 'round';

  ctx.beginPath();
  ctx.moveTo(x1 + jitter(), y1 + jitter());
  ctx.lineTo(x2 + jitter(), y2 + jitter());
  ctx.stroke();

  ctx.restore();
}

export function chalkRect(ctx, x, y, w, h, alpha = 1.0) {
  ctx.save();
  ctx.strokeStyle = chalkColor.replace(/[\d.]+\)$/, `${alpha})`);
  ctx.lineWidth = 2;
  ctx.shadowColor = chalkGlow;
  ctx.shadowBlur = shadowBlur;

  ctx.strokeRect(x + jitter(), y + jitter(), w, h);

  ctx.restore();
}

export function drawCursor(ctx, x, y, blinkPhase) {
  if (blinkPhase < 0.5) {
    ctx.save();
    ctx.fillStyle = chalkColor;
    ctx.fillRect(x, y - 12, 2, 16);
    ctx.restore();
  }
}
